<iu-input-file-ui
  customUpload="true"
  [auto]="false"
  [isAttachment]="true"
  [type]="fromNotes ? 'NOTES' : 'ATTACHEMENT'"
  [fromNotes]="fromNotes"
  [multiple]="true"
  [data]="{ isParam: false, columnName: 'join-file' }"
  [searchInformations]="baseSearch"
  [additionalUploadInformations]="additionalInformations"
  (nbUploadedFilesChangeEmitter)="updateNbUploadedFiles($event)"
  (uploadEnd)="uploadEnd.emit($event)"
  [adTable_ID]="adTable_ID"
  [adTab_ID]="adTab_ID"
  [record_id]="record_id">
</iu-input-file-ui>
